// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"132":"css/gastos","252":"css/app","253":"css/stylus","660":"/js/vendor","909":"css/proyectos"}[chunkId] + ".css";
};